var SwitchComponent;

(function($) {
	SwitchComponent = Vue.component('switch-vue', {
		template: '#switch-vue',
		props: ['values', 'modificator', 'changeView', 'viewType']
	});

	/*$(function() {
		$('.switch').each(function(){
			var $items = $(this).find('.switch__item'),
				$close = $('.switch__close');

			/!*$items.on('click', function(e){
				e.preventDefault();
				$items.removeClass('active');
				$(this).addClass('active');
			});*!/

			/!*$close.on('click', function(e){
				e.preventDefault();
				$items.removeClass('active');
				$('.switch__item[data-view="list"]').addClass('active');
			});*!/
		});
	});*/
})(jQuery);